import { ColumnPlainObject } from './column.plainObject';
import { TransformPlainObject } from './transform.plainObject';

export class CastPlainObject extends TransformPlainObject {
    public columns: ColumnPlainObject[] = [];
}
